import React from 'react';

type BoundedProps = {
  as?: React.ElementType;
  className?: string;
  children: React.ReactNode;
};

export const Bounded: React.FC<BoundedProps> = ({
  as: Comp = 'section',
  className,
  children,
  ...rest
}) => {
  return (
    <Comp
      className={`px-4 py-8 md:px-6 md:py-10 lg:py-12 ${className || ''}`}
      {...rest}
    >
      <div className="mx-auto w-full max-w-6xl">{children}</div>
    </Comp>
  );
};
